import React, { useState, useEffect } from 'react';
import axios from '../../api/axiosConfig';
import { useLocation } from 'react-router-dom';

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [okMsg, setOkMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  // NEU: Beim Aufruf der Seite boardId & inviteToken sichern
  // und falls bereits eingeloggt -> Einladung SOFORT einlösen
  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    const bid = qs.get('boardId');
    const tok = qs.get('inviteToken');

    if (bid) localStorage.setItem('pendingBoardId', bid);
    if (tok) localStorage.setItem('pendingInviteToken', tok);

    const hasJwt = !!localStorage.getItem('token');
    if (hasJwt && bid && tok) {
      (async () => {
        try {
          // Wichtig: boardId als Zahl schicken
          await axios.post('/invites/accept', {
            boardId: Number(bid),
            inviteToken: tok,
          });
          setOkMsg('Einladung angenommen. Weiterleitung …');
        } catch (e) {
          console.error('Invite-Accept auf /register:', e);
          setError(e?.response?.data?.error || 'Einladung konnte nicht eingelöst werden.');
        } finally {
          // kurze Pause, dann zur Startseite
          setTimeout(() => {
            window.location.assign('/'); // kein Router nötig
          }, 800);
        }
      })();
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setOkMsg('');

    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen haben.');
      return;
    }
    if (password !== confirm) {
      setError('Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      // Registrieren (Backend sendet Aktivierungs-Mail, kein Token zurück)
      const res = await axios.post('/register', { name, email, password });

      // (zusätzlich) URL-Parameter für nach Login merken
      const query = new URLSearchParams(location.search);
      const boardId = query.get('boardId');
      const inviteToken = query.get('inviteToken');
      if (boardId) localStorage.setItem('pendingBoardId', boardId);
      if (inviteToken) localStorage.setItem('pendingInviteToken', inviteToken);

      setOkMsg(
        res?.data?.message ||
          'Registrierung erfolgreich. Bitte prüfe deine E-Mails und aktiviere deinen Account.'
      );

      setName('');
      setEmail('');
      setPassword('');
      setConfirm('');
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.error || 'Registrierungsfehler (500).');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <h2>Registrieren</h2>

      {error && <p className="form-error" role="alert">{error}</p>}
      {okMsg && <p className="form-success">{okMsg}</p>}

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          autoComplete="name"
          disabled={loading}
        />

        <input
          type="email"
          placeholder="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          disabled={loading}
        />

        <input
          type="password"
          placeholder="Passwort (min. 8 Zeichen)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="new-password"
          disabled={loading}
        />

        <input
          type="password"
          placeholder="Passwort wiederholen"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
          autoComplete="new-password"
          disabled={loading}
        />

        <button type="submit" className="btn btn-block" disabled={loading}>
          {loading ? 'Registriere…' : 'Registrieren'}
        </button>
      </form>

      {new URLSearchParams(location.search).get('boardId') && (
        <p className="form-hint">
          Hinweis: Du bist über eine Einladung gekommen. Falls du schon eingeloggt bist,
          wird sie automatisch eingelöst.
        </p>
      )}
    </div>
  );
}

export default Register;
